import {cn, cva} from 'platform/shared';

import {ComponentPropsWithRef} from 'react';

const placeholderVariants = cva(
  'pointer-events-none absolute bottom-0 left-[9px] top-[7px] inline-flex select-none justify-center overflow-hidden text-ellipsis text-[length:var(--text-size-small)] text-[var(--color-tertiary)]'
);

export function Placeholder(props: ComponentPropsWithRef<'div'>) {
  return <div {...props} className={cn(placeholderVariants(), props.className)} />;
}
